<!--
 * @Description:  分页组件
 * @Date: 2020-07-20 11:00:11
 * @LastEditTime: 2020-12-31 10:53:20
--> 
<template>
  <div class="pageContain">
    <el-pagination
      :current-page.sync="curPage"
      :page-size.sync="pageSize"
      :page-sizes="pageSizes"
      :background="true"
      layout="total, sizes,prev, pager, next"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 30
    },
    pageSizes: {
      type: Array,
      default() {
        return [50, 100, 500, 1000, 2000, 5000, 10000];
      }
    }
  },
  // 收入数据汇总   汇总翻页  日期选择加快捷方式  一键到底 
  computed: {
    curPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      }
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit("update:limit", val);
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("pagination", { page: val, limit: this.pageSize });
    },
    handleSizeChange(val) {
      this.$emit("pagination", { page: this.curPage, limit: val });
    }
  }
};
</script>

<style>
.pageContain {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>